export default __webpack_public_path__ + "static/media/16.f8ddcfcf.png";